"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _react = _interopRequireWildcard(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

require("../styles/_asset-details.scss");

var AssetDetail = function AssetDetail(a) {
  var b = a.title,
      c = a.subTitle,
      d = a.fileName;
  return _react["default"].createElement("div", {
    className: "library-asset-details"
  }, _react["default"].createElement("div", null, _react["default"].createElement("p", {
    className: "library-asset-details__text library-asset-details__title"
  }, _react["default"].createElement("strong", null, b || d)), _react["default"].createElement("p", {
    className: "library-asset-details__text library-asset-details__sub-title"
  }, c), b && b !== d ? _react["default"].createElement("div", {
    className: "library-asset-details__text library-asset-details__filename"
  }, _react["default"].createElement("strong", null, d)) : null));
},
    _default = (0, _react.memo)(AssetDetail);

exports["default"] = _default;